import styled from "@emotion/styled";

export const ChefInfoNavbar = styled('div')({ 
  backgroundColor: '#333',
  position: "fixed",
  top: '-50px',
  width: '100%',
  display: 'block',
  transition: "top 0.3s",
}) 